import AdminSidebar from "../components/AdminSidebar";

const AdminLayout = () => {
  return (
    <div className="admin-layout">
      {/* <AdminSidebar /> */}
      <AdminSidebar />
      <div className="admin-main">
        {/* <AdminHeader /> */}

        <div className="admin-content">
          {/* <Outlet /> */}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;